import dodologo from '../assets/images/dododotlog.png';
import { Flex, Stack, Text, Divider, Button } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';

function DeleteAccount() {
  
  const { t } = useTranslation();

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  return (
        <Flex px={4} py={4}        
              flex="1"
              bgColor="#ffffff">
        <Stack>
          <Button onClick={() => changeLanguage('en')}>English</Button>
          <Button onClick={() => changeLanguage('ko')}>한국어</Button>
          <Text px={4} py={8} fontWeight="bold" fontSize="xl">{t('DeleteAccount01')}</Text>
          <Text px={4} py={2} fontWeight="medium" fontSize="md">{t('DeleteAccount02')}</Text>
          <Text px={4} py={2} fontWeight="medium" fontSize="md">{t('DeleteAccount03')}</Text>
          <Divider />
          </Stack>
        </Flex>
  );
}


export default DeleteAccount;
